// Campus photo for /colleges/yale-university: CC BY-SA 4.0, by Namkota, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABranford_harkness2.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/yale-university/; credited under the photo.
const photo = {
    "slug": "yale-university",
    "alt": "Harkness Tower rising over the Branford College courtyard at Yale University in New Haven, Connecticut",
    "src": "/colleges/yale-university/campus-1600.webp",
    "srcSmall": "/colleges/yale-university/campus-800.webp",
    "srcMid": "/colleges/yale-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/yale-university/og.jpg",
    "title": "Branford harkness2",
    "author": "Namkota",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABranford_harkness2.jpg",
    "read": "2026-09-30"
};

export default photo;
